import React from 'react'

import { Close as CloseIcon } from '@material-ui/icons'
import {
  Dialog,
  Typography,
  IconButton,
  Toolbar,
  AppBar,
  Box,
} from '@material-ui/core'
import { Alert, AlertTitle } from '@material-ui/lab'

import { ExerciseView, LessonContentView } from '../'

import useStyles from './styles'

const DialogView = ({ lesson, open, onClose, courseModules }) => {
  const classes = useStyles()

  return (
    <Dialog open={open} onClose={onClose} fullScreen maxWidth>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
            <Typography variant="h6" className={classes.closeBtn}>
              Fechar
            </Typography>
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box pt={10}>
        <Box className={classes.alert}>
          <Alert severity="info">
            <AlertTitle>Modo de visualização</AlertTitle>
            Esta é uma pré-visualização da aula. Nenhuma alteração ou progresso
            será salvo enquanto você estiver neste modo.
          </Alert>
        </Box>
        {lesson?.kind === 'exercise' ? (
          <ExerciseView lesson={lesson} courseModules={courseModules} />
        ) : (
          <LessonContentView lesson={lesson} courseModules={courseModules} />
        )}
      </Box>
    </Dialog>
  )
}
export default DialogView
